export const dataGruposDrawer = [
  {
    "descripcion": "Ventas",
    "grupo": "ventas",
    "icon": "fa-cash-register",
    "order": 1
  },
  {
    "descripcion": "XML Comprobantes",
    "grupo": "xml",
    "icon": "fa-file-code",
    "order": 2
  },
  {
    "descripcion": "Contratos",
    "grupo": "contratos",
    "icon": "fa-handshake",
    "order": 3
  },
  {
    "descripcion": "Ordenes",
    "grupo": "ordenes",
    "icon": "fa-helmet-safety",
    "order": 4
  },
  // {
  //   "descripcion": "Recursos humanos",
  //   "grupo": "rrhh",
  //   "icon": "fa-restroom",
  //   "order": 5
  // },
  {
    "descripcion": "Inventario",
    "grupo": "inventario",
    "icon": "fa-box",
    "order": 6
  },
  {
    "descripcion": "CRM",
    "grupo": "crm",
    "icon": "fa-person-rays",
    "order": 7
  },
  {
    "descripcion": "Cajas",
    "grupo": "caja",
    "icon": "fa-sack-dollar",
    "order": 8
  },
  {
    "descripcion": "Bancos",
    "grupo": "bancos",
    "icon": "fa-vault",
    "order": 9
  },
  {
    "descripcion": "Usuarios",
    "grupo": "usuarios",
    "icon": "fa-solid fa-users-gear",
    "order": 10
  },
  {
    "descripcion": "Configuracion",
    "grupo": "configuracion",
    "icon": "fa-solid fa-gears",
    "order": 11
  },
  {
    "descripcion": "Catálogo",
    "grupo": "catalogo",
    "icon": "fa-store",
    "order": 12
  },
  {
    "descripcion": "Reportes",
    "grupo": "reportes",
    "icon": "fa-solid fa-database",
    "order": 13
  },
  {
    "descripcion": "Materiales",
    "grupo": "materiales",
    "icon": "fa-boxes-packing",
    "order": 14
  },
  {
    "descripcion": "Bodegas",
    "grupo": "bodegas",
    "icon": "solid fa-tents",
    "order": 15
  },
  {
    "descripcion": "Control de Egresos",
    "grupo": "egresos",
    "icon": "solid fa-box-archive",
    "order": 16
  },
  {
    "descripcion": "Caja de pagos",
    "grupo": "pagos",
    "icon": "fa-money-bills",
    "order": 17
  },
  {
    "descripcion": "Costeo",
    "grupo": "costos",
    "icon": "fa-diagram-project",
    "order": 18
  },
  {
    "descripcion":"KPI's",
    "grupo": "kpis",
    "icon": "fa-chart-pie",
    "order": 19
  },
  {
    "descripcion": "Personas",
    "grupo": "personas",
    "icon": "fa-user-gear",
    "order": 20
  },
  {
    "descripcion": "Analítica",
    "grupo": "analitica",
    "icon": "fa-chart-pie",
    "order": 21
  },
  {
    "descripcion": "Reportes Excel",
    "grupo": "report",
    "icon": "fa-file-excel",
    "order": 22
  },
]
